import { PushNotifications, PushNotificationSchema } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm'
import {
  IonApp,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon, IonItem, IonModal, IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonTitle,
  IonToolbar,
  isPlatform
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';
import { arrowBack } from 'ionicons/icons';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Authentication } from './components/Authentication';
import icon_alarma from "./images/icon_alarmas.svg";
import icon_alimentos from "./images/icon_alimentos.svg";
import icon_detalle from "./images/icon_detalle.svg";
import icon_plan from "./images/icon_plan.svg";
import icon_registro from "./images/icon_registro.svg";
import icon_videos from "./images/icon_videos.svg";
import AlarmasPage from './pages/AlarmasPage';
import AlimentosPage from './pages/AlimentosPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import PlanPage from './pages/PlanPage';
import RegistroPage from './pages/RegistroPage';
import SigninPage from './pages/SigninPage';
import SplashPage from './pages/SplashPage';
import VideoPage from './pages/VideoPage';
/* Theme variables */
import './theme/variables.css';

class App extends React.Component{

  state = {
    notification:{} as PushNotificationSchema,
    show:false
  }

  componentDidMount(){
      if(!isPlatform("desktop")){
        this.initNotifications()
      }
  }

  initNotifications = async () => {
    const permisions = await PushNotifications.checkPermissions()
    if(permisions.receive !== "denied"){
      PushNotifications.addListener("pushNotificationActionPerformed",e => {
        this.setState({notification:e.notification,show:true})
      })
      PushNotifications.addListener("registrationError",(error) => {
        console.error(error)
      })
      PushNotifications.addListener("registration",(token) => {
        FCM.getToken()
          .then((r) =>  console.log("FCM TOKEN: "+r.token))
          .catch((err) => console.error(err))
        FCM.subscribeTo({ topic: 'all' })
      })
      PushNotifications.register()
    }
  }

  render(){
    const {notification,show} = this.state
    return (
      <IonApp>
        <IonReactRouter>
          {
            Authentication.loginData ? (
              <IonTabs>
                <IonRouterOutlet>
                  <Route exact path="/home" component={HomePage} />
                  <Route exact path="/registro" component={RegistroPage} />
                  <Route exact path="/plan" component={PlanPage} />
                  <Route exact path="/alimentos" component={AlimentosPage} />
                  <Route exact path="/alarmas" component={AlarmasPage} />
                  <Route exact path="/videos" component={VideoPage} />
                  <Route exact path="/">
                    <Redirect to="/home" />
                  </Route>
                </IonRouterOutlet>
                <IonTabBar slot="bottom">
                  <IonTabButton tab="home" href="/home">
                    <IonIcon icon={icon_detalle} />
                  </IonTabButton>
                  <IonTabButton tab="registro" href="/registro">
                    <IonIcon icon={icon_registro} />
                  </IonTabButton>
                  <IonTabButton tab="plan" href="/plan">
                    <IonIcon icon={icon_plan} />
                  </IonTabButton>
                  <IonTabButton tab="alimentos" href="/alimentos">
                    <IonIcon icon={icon_alimentos} />
                  </IonTabButton>
                  <IonTabButton tab="alarmas" href="/alarmas">
                    <IonIcon icon={icon_alarma} />
                  </IonTabButton>
                  <IonTabButton tab="videos" href="/videos">
                    <IonIcon icon={icon_videos} />
                  </IonTabButton>
                </IonTabBar>
              </IonTabs>
            ):(
              <IonRouterOutlet>
                <Route path="/" exact component={SplashPage} />
                <Route path="/login" exact component={LoginPage} />
                <Route path="/registro" exact component={SigninPage} />
              </IonRouterOutlet>
            )
          }
        </IonReactRouter>
        <IonModal isOpen={show} onDidDismiss={() => this.setState({show:false})}>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonButton onClick={() => this.setState({show:false})}><IonIcon icon={arrowBack} /></IonButton>
              </IonButtons>
              <IonTitle>{notification.data?.title || notification.title}</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            {
              !notification.data && (
                <IonItem lines="none">
                { notification.body }
                </IonItem>
              )
            }
            {
              notification.data && (
                <IonItem lines="none">
                { notification.data?.image && (<img src={notification.data?.image} className="img-fluid" alt="" />)}
                </IonItem>
              )
            }
            {
              notification.data && (
                <IonItem lines="none">
                  { notification.data?.body }
                </IonItem>
              )
            }
            {
              notification.data?.link && (
                <IonButton href={notification.data?.link} target="_blank">Ver más..</IonButton>
              )
            }
            {
              !notification.data && (
                <IonButton href={notification.link} target="_blank">Ver más..</IonButton>
              )
            }
          </IonContent>
        </IonModal>
      </IonApp>
    )
  }
}
export default App;
